import { Box, Link, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import AppCard, { AppCardProps } from "../../components/common/AppCard/AppCard.tsx";
import LinkConstants from "../../constants/LinkConstants";
import RouterConstants from "../../constants/RouterConstants";
import useSecureNavigate from "../../hooks/useSecureNavigate.tsx";
import { isBriaDemosOrg, isMccannOrg, isPublicisOrg, isWppPocOrg } from "../../utils";
import PlatformHubSection from "./Section/PlatformHubSection.tsx";

import briaLogo from "../../assets/images/pngs/bria-logo.png";
import { HubIntegrations, IntegrationOption } from "./HubIntegrations/HubIntegrations.tsx";
import styles from "./PlatformHub.module.scss";

const PlatformHub = () => {
	const navigate = useSecureNavigate();
	const { t } = useTranslation("translation", { keyPrefix: "platformHub" });

	const integrationsConfig: IntegrationOption[] = [
		"API",
		"IFRAME",
		"SOURCE_CODE",
		"MCP_SERVER",
		"COMFY_UI",
		"FIGMA",
		"PHOTOSHOP",
	];

	const appsCards: AppCardProps[] = [
		{
			card: "imageGeneration",
			onClick: () => navigate(RouterConstants.TEXT_TO_IMAGE.path),
		},
		{
			card: "textToVector",
			onClick: () => navigate(RouterConstants.TEXT_TO_VECTOR.path),
		},
		{
			card: "imageEditing",
			onClick: () => navigate(RouterConstants.IMAGE_TO_IMAGE.path),
		},
		{
			card: "tailoredGeneration",
			onClick: () => navigate(RouterConstants.APPS.TG.path),
		},
		// {
		// 	card: "adsGenerator",
		// 	onClick: () => navigate(RouterConstants.ADS_GENERATOR.path),
		// },
		// TODO: To add it later
		// {
		// 	card: "adsEditor",
		// 	onClick: () => navigate(RouterConstants.ADS_EDITOR.path),
		// },
		// {
		// 	card: "automotive",
		// 	onClick: () => navigate(RouterConstants.AUTOMOTIVE.path, { state: { from: location.pathname }}),
		// },
	];

	if (isMccannOrg() || isBriaDemosOrg() || isWppPocOrg() || isPublicisOrg()) {
		appsCards.unshift({
			card: "productPlacement",
			onClick: () => navigate(RouterConstants.PRODUCT_PLACEMENT_GALLERY.path),
		});
	}

	return (
		<Box className={styles.container}>
			<Typography className={styles.title}>{t("title")}</Typography>
			<PlatformHubSection className={styles.integrations} title={t("integrations.title")}>
				<Box className={styles.integrationsRow}>
					<HubIntegrations integrations={integrationsConfig} />
				</Box>
			</PlatformHubSection>
			<PlatformHubSection title={t("appCards.title")}>
				<Box className={styles.appsCards}>
					{appsCards.map((app) => (
						<AppCard card={app.card} onClick={app.onClick} />
					))}
				</Box>
			</PlatformHubSection>
			<Box className={styles.footer}>
				<Box className={styles.termsAndPrivacy}>
					<Link
						className={styles.subLink}
						href={LinkConstants.PRIVACY_POLICY}
						target="_blank"
						rel="noopener noreferrer"
					>
						{t("privacyPolicy")}
					</Link>
					<Link
						className={styles.subLink}
						href={LinkConstants.LEGAL_LOBBY}
						target="_blank"
						rel="noopener noreferrer"
					>
						{t("termsOfUse")}
					</Link>
				</Box>
				<img className={styles.BriaIcon} src={briaLogo} />
				<Typography className={styles.allRightsSection}>{t("allRightsReservedToBRIA")}</Typography>
			</Box>
		</Box>
	);
};

export default observer(PlatformHub);
